module.exports = __webpack_public_path__ + "resources/img/img_watchall_nms2.5b6c4e01b1c95a75521748a4f4b5e9b6.png";